import config from '../../config';
import Administrator from '../../pages/Administrator';
import Dashboard from '../../pages/Dashboard';
import Log from '../../pages/Log';
import Policy from '../../pages/Policy';
import Quarantine from '../../pages/Quarantine';
import Report from '../../pages/Report';
import { PermissionNameEnum } from '@Types/permissions';

const sideMenuItem = config.ui.hideFeature.sideBar;
const sideRouter = [
  {
    path: '/dashboard',
    element: Dashboard,
    name: 'side.group.dashboard',
    show: !sideMenuItem.dashboard,
    permission: [
      PermissionNameEnum.dashboard,
      PermissionNameEnum.administrator,
    ],
  },
  {
    path: '/report',
    name: 'side.group.report',
    element: Report,
    show: !sideMenuItem.report,
    permission: [PermissionNameEnum.report],
  },
  {
    path: '/logs',
    name: 'side.group.log',
    element: Log,
    show: !sideMenuItem.log,
    permission: [PermissionNameEnum.log],
  },
  {
    path: '/policy',
    name: 'side.group.policy',
    element: Policy,
    show: !sideMenuItem.policy,
    permission: [
      PermissionNameEnum.atpPolicy,
      PermissionNameEnum.dlpPolicy,
      PermissionNameEnum.administrator,
    ],
  },
  {
    path: '/quarantine',
    //TODO:
    // name: 'side.group.quarantine',
    name: 'side.group.operations',
    element: Quarantine,
    show: !sideMenuItem.quarantine,
    permission: [PermissionNameEnum.quarantine],
  },
  {
    path: 'visionOne',
    name: 'side.group.detectionAndResponse',
    element: () => {
      return <></>;
    },
    show: !sideMenuItem.visionOne,
  },
  {
    path: '/administration',
    name: 'side.group.administrator',
    element: Administrator,
    permission: [PermissionNameEnum.administrator],
    show: !sideMenuItem.administrator,
  },
];
export default sideRouter;
